/**
 * UPS Swiper
 */
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

let uspSliderSettings = {
	modules: [ Autoplay ],
	slidesPerView: 1,
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	breakpoints: {
		992: {
			slidesPerView: 'auto',
		},
	},
};
uspSliderSettings = wp.hooks.applyFilters( 'qala_theme.filter.usp_slider_settings', uspSliderSettings );
const uspSlides = document.querySelectorAll( '.usp-swiper .swiper-slide' ).length;

if ( uspSlides > 1 ) {
	new Swiper( '.usp-swiper', uspSliderSettings );
}
